const actions = {
    READ_BANK_ACCOUNTS_REQUEST: 'READ_BANK_ACCOUNTS_REQUEST',
    READ_BANK_ACCOUNTS_SUCCESS: 'READ_BANK_ACCOUNTS_SUCCESS',
    READ_BANK_ACCOUNTS_ERROR: 'READ_BANK_ACCOUNTS_ERROR',
    READ_BANK_ACCOUNT_REQUEST: 'READ_BANK_ACCOUNT_REQUEST',
    READ_BANK_ACCOUNT_SUCCESS: 'READ_BANK_ACCOUNT_SUCCESS',
    READ_BANK_ACCOUNT_ERROR: 'READ_BANK_ACCOUNT_ERROR',
    POPULATE_BANK_ACCOUNT: 'POPULATE_BANK_ACCOUNT',
    CREATE_BANK_ACCOUNT_REQUEST: 'CREATE_BANK_ACCOUNT_REQUEST',
    CREATE_BANK_ACCOUNT_SUCCESS: 'CREATE_BANK_ACCOUNT_SUCCESS',
    CREATE_BANK_ACCOUNT_ERROR: 'CREATE_BANK_ACCOUNT_ERROR',
    UPDATE_BANK_ACCOUNT_REQUEST: 'UPDATE_BANK_ACCOUNT_REQUEST',
    UPDATE_BANK_ACCOUNT_SUCCESS: 'UPDATE_BANK_ACCOUNT_SUCCESS',
    UPDATE_BANK_ACCOUNT_ERROR: 'UPDATE_BANK_ACCOUNT_ERROR',
    BANK_ACCOUNT_ARCHIVE_REQUEST: 'BANK_ACCOUNT_ARCHIVE_REQUEST',
    BANK_ACCOUNT_ARCHIVE_SUCCESS: 'BANK_ACCOUNT_ARCHIVE_SUCCESS',
    BANK_ACCOUNT_ARCHIVE_ERROR: 'BANK_ACCOUNT_ARCHIVE_ERROR',
    BANK_ACCOUNT_DELETE_REQUEST: 'BANK_ACCOUNT_DELETE_REQUEST',
    BANK_ACCOUNT_DELETE_SUCCESS: 'BANK_ACCOUNT_DELETE_SUCCESS',
    BANK_ACCOUNT_DELETE_ERROR: 'BANK_ACCOUNT_DELETE_ERROR',
    BANK_ACCOUNT_SET_PARENT_ID: 'BANK_ACCOUNT_SET_PARENT_ID',

    ADD_BANK_ACCOUNT: 'ADD_BANK_ACCOUNT',
    RESET_BANK_ACCOUNT: 'RESET_BANK_ACCOUNT',

    readBankAccounts: request => ({
        type: actions.READ_BANK_ACCOUNTS_REQUEST,
        request,
    }),
    readBankAccount: id => ({
        type: actions.READ_BANK_ACCOUNT_REQUEST,
        id,
    }),
    populateBankAccount: (request, reset = false) => ({
        type: actions.POPULATE_BANK_ACCOUNT,
        request,
        reset,
    }),
    createBankAccount: request => ({
        type: actions.CREATE_BANK_ACCOUNT_REQUEST,
        request,
    }),
    updateBankAccount: (id, request) => ({
        type: actions.UPDATE_BANK_ACCOUNT_REQUEST,
        id,
        request,
    }),
    setParentId: parentId => ({
        type: actions.BANK_ACCOUNT_SET_PARENT_ID,
        parentId,
    }),
    archive: (id, request) => ({
        type: actions.BANK_ACCOUNT_ARCHIVE_REQUEST,
        id,
        request,
    }),
    delete: id => ({
        type: actions.BANK_ACCOUNT_DELETE_REQUEST,
        id,
    }),
    addBankAccount: bankAcc => ({
        type: actions.ADD_BANK_ACCOUNT,
        bankAcc,
    }),
    resetBankAccount: () => ({
        type: actions.RESET_BANK_ACCOUNT,
    }),
};
export default actions;
